import type {ThemeConfig} from 'antd/es/config-provider/context';

import {DATE_PICKER_POPUP_Z_INDEX} from '../../utils/pickerPopup';

/** Theme tokens for the remaining antd DatePicker surfaces (antd-jalali). */
export const antdDatePickerTheme: ThemeConfig = {
  token: {
    fontFamily: 'IRANSans',
    colorPrimary: 'rgb(255, 102, 31)',
    zIndexPopupBase: DATE_PICKER_POPUP_Z_INDEX
  }
};
